"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWarehousePath = exports.warehousePathSchema = void 0;
var yup = require("yup");
var WarehousePathPoint_1 = require("./WarehousePathPoint");
var WarehouseActiveTime_1 = require("./WarehouseActiveTime");
exports.warehousePathSchema = yup.object().shape({
    id: yup.string().required(),
    name: yup.string().required(),
    isAlwaysActive: yup.boolean().required(),
    isDraft: yup.boolean().optional(),
    activeTimes: yup.array().of(WarehouseActiveTime_1.warehouseActiveTimeSchema).optional(),
    deliveryTime: yup.number().optional(),
    points: yup.array().of(WarehousePathPoint_1.warehousePathPointSchema).required(),
});
function isWarehousePath(obj) {
    return exports.warehousePathSchema.isValidSync(obj);
}
exports.isWarehousePath = isWarehousePath;
